import { merge, Observable } from 'rxjs';

import {
  FetchParams,
  Middleware,
  RequestContext,
  ResponseContext,
} from '@neptune/shared/core-apis-middleware-domain';

export type ConnectivityServiceType = {
  readonly isLocked: boolean;
  readonly asObservable: Observable<unknown>;
  asOpenApiMiddleware: () => Middleware;
};

export class ConnectivityService implements ConnectivityServiceType {
  private services: ConnectivityServiceType[];

  constructor(...services: Array<ConnectivityServiceType | undefined>) {
    this.services = services.filter((service) => service !== undefined);
  }

  get asObservable(): Observable<unknown> {
    return merge(...this.services.map((service) => service.asObservable));
  }

  get isLocked(): boolean {
    return this.services.some((service) => service.isLocked);
  }

  asOpenApiMiddleware(): Middleware {
    return {
      pre: async (context: RequestContext): Promise<FetchParams | void> => {
        for (const service of this.services) {
          await service.asOpenApiMiddleware().pre?.(context);
        }
      },
      post: async (context: ResponseContext): Promise<Response | void> => {
        for (const service of this.services) {
          await service.asOpenApiMiddleware().post?.(context);
        }
      },
    };
  }
}
